import merge from './common/utils/merge';

const { REACT_APP_CS_PROJECT, REACT_APP_CS_REPO, REACT_APP_CS_BRANCH } = process.env;

const defaults = {
  auth: {
    clientId: '40217954-1ed3-4369-81c4-716e8c759260',
    redirectUri: `${location.protocol}//${location.host}`,
    postLogoutRedirectUri: `${location.protocol}//${location.host}`,
    domain: `http://localhost.test:7001`,
    scope: 'openid email profile',
    responseType: 'code id_token token',
    idTokenKey: 'idToken',
    accessTokenKey: 'accessToken',
  },
  cloudfront: {
    videoDomain: 'https://d2ycorfhx8xf7t.cloudfront.net',
    withCredentials: false,
  },
  environment: process.env.REACT_APP_ENV,
  intercom: {
    appId: 'n3q23bxr',
  },
  sentryEnvironmentTag: 'development',
  stripe: {
    connectClientId: 'ca_CsfvJiXenork7pUhqmiumjZdOuQaHXq6',
    publishableKey: 'pk_test_VEtv55y16UUCutixtaKq42RH',
  },
  validationMessages: {
    'string.email': 'Must be a valid email',
  },
  adWordsKey: 'AW-926426886',
  googleAnalyticsKey: 'UA-60684002-7',
  tapfiliateKey: '4572-bf656a',
};

const environments = {
  development: {},
  qa: {
    auth: {
      domain: `https://${REACT_APP_CS_PROJECT}-${REACT_APP_CS_REPO}-oidc-${REACT_APP_CS_BRANCH}.synsit.es`,
    },
    sentryEnvironmentTag: 'qa',
  },
  staging: {
    auth: {
      clientId: 'f8eb655c-ab30-4bf6-aa0c-e502f48c54b8',
      domain: `https://staging-accounts.tathatagolf.com`,
    },
    cloudfront: {
      videoDomain: 'https://dlwa3585iglsm.cloudfront.net',
      withCredentials: true,
    },
    sentryEnvironmentTag: 'staging',
  },
  production: {
    auth: {
      clientId: '8b60d3a2-a771-48c3-82b7-db0b4ae09e25',
      domain: `https://account.tathatagolf.com`,
    },
    cloudfront: {
      videoDomain: 'https://d11saezyr3jiey.cloudfront.net',
      withCredentials: true,
    },
    intercom: {
      appId: 'wnkxkm3v',
    },
    sentryEnvironmentTag: 'production',
    stripe: {
      connectClientId: 'ca_CsfvaI5h2Dp43oXzJaRwy40Q5stRfp33',
      publishableKey: 'pk_live_y4PaH0XEjTMZwCRrMrqb0yLp',
    },
    googleAnalyticsKey: 'UA-60684002-2',
  },
};

export default merge(defaults, environments[process.env.REACT_APP_ENV]);



// WEBPACK FOOTER //
// ./src/config.js